import { InputOtp } from "primereact/inputotp";

const SecurityValidationOtpInput = ({ value, onChange, disabled, length = 4 }) => (
  <div className="security-validation-otp">
    <InputOtp
      value={value}
      onChange={(e) => onChange(String(e.value ?? ""))}
      length={length}
      integerOnly
      disabled={disabled}
    />
  </div>
);

export default SecurityValidationOtpInput;
